import { faqData } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm">关于52吃瓜网，你想知道的都在这里</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-foreground-800 font-bold text-sm md:text-base mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q:</span>
                {faq.question}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed pl-5">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}